import React from 'react'

export default function Service() {
  return (
    <>
    <h1  className="text-center text-2xl md:text-3xl font-semibold md:font-bold bg-gradient-to-r from-red-500 via-yellow-400 to-green-50 bg-clip-text text-transparent hidden md:block">
        Welcome to our Service Info Section
   </h1>
    <section className="w-full py-20 bg-gradient-to-br from-white via-purple-500 to-pink-50">
  <div className="max-w-7xl  px-6">
    
    <div className="text-center mb-16">
      <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
        Our Digital Marketing Services
      </h2>
      <p className="text-gray-600 text-lg max-w-2xl mx-auto">
        We provide creative and result-driven digital marketing solutions to grow your business online.
      </p>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">

      <div className="bg-white/70 backdrop-blur-lg p-8 rounded-3xl shadow-lg hover:shadow-2xl transition duration-300 border border-purple-100">
        <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-purple-100 text-3xl mb-6">
          📈
        </div>
        <h3 className="text-2xl font-semibold text-gray-800 mb-3">
          SEO Optimization
        </h3>
        <p className="text-gray-600 leading-relaxed">
          Improve your website ranking on search engines and increase organic traffic with advanced SEO strategies.
        </p>
      </div>

      <div className="bg-white/70 backdrop-blur-lg p-8 rounded-3xl shadow-lg hover:shadow-2xl transition duration-300 border border-pink-100">
        <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-pink-100 text-3xl mb-6">
          📱
        </div>
        <h3 className="text-2xl font-semibold text-gray-800 mb-3">
          Social Media Marketing
        </h3>
        <p className="text-gray-600 leading-relaxed">
          Grow your audience and build strong engagement through professional social media campaigns.
        </p>
      </div>

      <div className="bg-white/70 backdrop-blur-lg p-8 rounded-3xl shadow-lg hover:shadow-2xl transition duration-300 border border-blue-100">
        <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-blue-100 text-3xl mb-6">
          🎯
        </div>
        <h3 className="text-2xl font-semibold text-gray-800 mb-3">
          Google Ads
        </h3>
        <p className="text-gray-600 leading-relaxed">
          Reach targeted customers quickly with highly optimized Google advertising campaigns.
        </p>
      </div>

      <div className="bg-white/70 backdrop-blur-lg p-8 rounded-3xl shadow-lg hover:shadow-2xl transition duration-300 border border-yellow-100">
        <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-yellow-100 text-3xl mb-6">
          ✍️
        </div>
        <h3 className="text-2xl font-semibold text-gray-800 mb-3">
          Content Marketing
        </h3>
        <p className="text-gray-600 leading-relaxed">
          Create valuable and engaging content that attracts customers and builds brand trust.
        </p>
      </div>

      <div className="bg-white/70 backdrop-blur-lg p-8 rounded-3xl shadow-lg hover:shadow-2xl transition duration-300 border border-green-100">
        <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-green-100 text-3xl mb-6">
          📧
        </div>
        <h3 className="text-2xl font-semibold text-gray-800 mb-3">
          Email Marketing
        </h3>
        <p className="text-gray-600 leading-relaxed">
          Connect directly with customers through professional email campaigns and promotions.
        </p>
      </div>

      <div className="bg-white/70 backdrop-blur-lg p-8 rounded-3xl shadow-lg hover:shadow-2xl transition duration-300 border border-cyan-100">
        <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-cyan-100 text-3xl mb-6">
          🌐
        </div>
        <h3 className="text-2xl font-semibold text-gray-800 mb-3">
          Website Management
        </h3>
        <p className="text-gray-600 leading-relaxed">
          Maintain and optimize your website performance for better user experience and conversions.
        </p>
      </div>

    </div>
  </div>
</section>
    </>

  )
}
